// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__192Xi","detailsBorder":"styles_detailsBorder__2kxql"};